import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Hero banner — a single static background image, applied in CSS so it scales
 * and crops the same way at every breakpoint.
 */
@Component({
  selector: 'app-landing-hero',
  templateUrl: './landing-hero.component.html',
  styleUrls: ['./landing-hero.component.scss'],
  imports: [TranslateModule],
})
export class LandingHeroComponent {}
